const countdownTimer = () => {

  const timers = document.querySelectorAll('.bf-timer');
  if (!timers) return;

  function getEndOfDay() {
    const now = new Date();
    // check if the domain is .de, if so, set end date to Dec 16th
    let end = new Date('2025-12-18T23:59:59.999Z');
    if (window.location.hostname.endsWith('.de')) {
      end = new Date('2025-12-16T23:59:59.999Z');
    }
    return { now, end };
  }

  function updateTimer() {
    const { now, end } = getEndOfDay();
    let diff = end - now;

    if (diff < 0) {
      timers.forEach(timer => timer.style.display = 'none');
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);
    const hrs = totalHours % 24;
    const mins = totalMinutes % 60;
    const secs = totalSeconds % 60;

    timers.forEach(timer => {
      const daysEl = timer.querySelectorAll('[data-unit="days"]');
      const hoursEl = timer.querySelectorAll('[data-unit="hours"]');
      const minutesEl = timer.querySelectorAll('[data-unit="minutes"]');
      const secondsEl = timer.querySelectorAll('[data-unit="seconds"]');

      daysEl.forEach(el => el.textContent = String(totalDays).padStart(2, '0'));
      hoursEl.forEach(el => el.textContent = String(hrs).padStart(2, '0'));
      minutesEl.forEach(el => el.textContent = String(mins).padStart(2, '0'));
      secondsEl.forEach(el => el.textContent = String(secs).padStart(2, '0'));
    });
  }

  updateTimer();
  setInterval(updateTimer, 1000);
};

export default countdownTimer;


